import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal/Modal';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './KYCConfirmMitekModalComponent.css';
var classes = getBEMClasses('kyc-confirm-mitek');
var KYCConfirmMitekModal = function KYCConfirmMitekModal(props, context) {
  var onConfirm = props.onConfirm,
    close = props.close,
    isOpen = props.isOpen;
  return React.createElement(Modal, {
    isOpen: isOpen,
    title: context.t('Confirm Identification Documents'),
    close: close,
    footer: {
      buttonText: context.t('Confirm'),
      onClick: onConfirm,
      overrideClose: true
    }
  }, React.createElement('div', null, React.createElement('p', {
    className: classes('description')
  }, context.t('Thanks for applying to increase your Verification Level. Once we have reviewed and approved your documents, you will be able to use all features of our platform.'))));
};
KYCConfirmMitekModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
KYCConfirmMitekModal.contextTypes = {
  t: PropTypes.func.isRequired
};
export default KYCConfirmMitekModal;